import React from 'react';
import styled from 'styled-components';

const ResponsiveBlock = styled.div`
  // padding-left: 1rem;
  // padding-right: 1rem;
  width: 1024px;
  margin: 0 auto;
  // background: red;

  @media (max-width: 1024px) {
    // width: 768px;
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Responsive = ({ children, ...rest }) => {
  return (
    <div className="Responsive">
      <ResponsiveBlock {...rest}>
        {children}
      </ResponsiveBlock>      
    </div>
  );
};

export default Responsive;